<template>
    <div class="big-screen-map" v-loading="loading">

        <div id="the-map"></div>
        <el-button class="map-close" @click="$_closeMap">
            <i class="el-icon-close"></i>
        </el-button>

        <div class="alert-contents">
            <div id="li-container">
                <li v-for="(item, index) in alertContent" :key="index">{{ item }}</li>
            </div>
        </div>

    </div>
</template>

<script>
    import '../../node_modules/echarts/map/js/china.js'
    export default {
        name: "big-screen-map",
        data() {
            return {
                province: [],
                geoCoordMap: {},
                site: [],
                alertContent: [],
                allhosts: { 
                    'code':1, 
                    'data':[
                        {
                            'name': 'testsite1',
                            'site_total': '30', 
                            'longitude': '111.12', 
                            'latitude': '40.16', 
                            'address': '',
                            'site_offline_total': '0',
                            'alert_untreated_total': '1', 
                            'type': '3'
                        },
                        {
                            'name': 'testsite2',
                            'site_total': '50', 
                            'longitude': '115.12', 
                            'latitude': '28.16', 
                            'address': '',
                            'site_offline_total': '0',
                            'alert_untreated_total': '1', 
                            'type': '3'
                        },
                        {
                            'name': '杭州',
                            'site_total': '40', 
                            'longitude': '120.19', 
                            'latitude': '30.26', 
                            'address': '',
                            'site_offline_total': '0',
                            'alert_untreated_total': '1', 
                            'type': '3'
                        },
                        {
                            'name': 'testsite3',
                            'site_total': '60', 
                            'longitude': '105.19', 
                            'latitude': '38.26', 
                            'address': '',
                            'site_offline_total': '0',
                            'alert_untreated_total': '1', 
                            'type': '3'
                        },
                        {
                            'name': 'test4',
                            'site_total': '60', 
                            'longitude': '106.19', 
                            'latitude': '33.26', 
                            'address': '',
                            'site_offline_total': '0',
                            'alert_untreated_total': '1', 
                            'type': '3'
                        }
                    ]
                },
                loading: true,
            }
        },
        methods: {
            // 初始化
            $_initMap() {
                // 初始化echarts实例
                var myChart = echarts.init(document.getElementById('the-map'))

                var data = this.province
                var geoCoordMap = this.geoCoordMap
                var site = this.site

                var convertData = function (data) {
                    var res = [];
                    for (var i = 0; i < data.length; i++) {
                        var geoCoord = geoCoordMap[data[i].name];
                        if (geoCoord) {
                            res.push({
                                name: data[i].name,
                                value: geoCoord.concat(data[i].value),
                                site: site[i],
                            })
                        }

                    }
                    return res;
                }

                // 连线数组 
                var HZdata = []
                this.province.map((item) => { HZdata.push(item.name) })
                var convertLineData = function (data) {
                    var res = []; 
                    for(var i = 0; i < data.length; i++) {
                        var dataItem = data[i];
                        var fromCoord = geoCoordMap['杭州市'];
                        var toCoord = geoCoordMap[dataItem];
                        if(fromCoord && toCoord) {
                            res.push([{
                                coord: fromCoord // 起点坐标
                            }, {
                                coord: toCoord // 终点坐标
                            }])
                        }
                    }
                    return res
                }
                var option = {
                    title: {
                        text: '告警分布图',
                        left: 'start',
                        textStyle: {
                            color: '#fff',
                            fontSize: 32,
                        }
                    },
                    tooltip : {
                        trigger: 'item',
                        extraCssText: 'white-space:pre-wrap',
                        formatter: (params, ticket, callback) => {
                            return `<div class="tooltip-item the-normal">正常站点：${params.data.site.normal} 个</div>
                                    <div class="tooltip-item the-alert">待处理告警：${params.data.site.alert} 个</div>
                                    <div class="tooltip-item the-offline">失联站点：${params.data.site.offline} 个</div>`
                        }
                    },
                    geo: { // 地图配置
                        map: 'china', // 表示中国地图
                        roam: false, //关闭缩放
                        zoom: 1.2,
                        label: {
                            normal: {
                                show: false, // 是否显示对应地名
                                textStyle: {
                                    color: 'rgba(0,0,0,0)'
                                }
                            },
                            emphasis: {
                                show: false,
                            }
                        },
                        center: [114, 36],
                        itemStyle: {
                            normal: {
                                areaColor: 'rgba(31, 153, 183, 0)',
                                borderColor: 'rgba(31, 153, 183)',
                                borderWidth: 1,
                            },
                            emphasis: {
                                areaColor: 'rgba(31, 153, 183, .3)',
                            }
                        }
                        
                    },
                    series : [
                        {
                            name: '',
                            type: 'effectScatter',
                            coordinateSystem: 'geo',
                            data: convertData(data),
                            symbolSize: function (val) {
                                // 按站点数分四个等级
                                if(val[2] <= 5) val[2] = 1
                                else if(val[2] > 5 && val[2] <= 15) val[2] = 2
                                else if(val[2] > 15 && val[2] <= 25) val[2] = 3
                                else val[2] = 4
                                // return * 数字控制大小
                                return val[2] * 8;
                            },
                            showEffectOn: 'render',  //'emphasis' hover显示，'render' 绘制完成后显示 
                            rippleEffect: {            //特效配置
                                brushType: 'stroke',
                                scale: 3.0
                            },
                            hoverAnimation: true,
                            label: {
                                normal: {
                                    formatter: '{b}',
                                    position: 'right',
                                    show: false
                                },
                                emphasis: {
                                    show: true
                                }
                            },
                            itemStyle: {
                                normal: {
                                    // 站点颜色
                                    color: (params) => { 
                                        if(params.data.site.offline - 0 > 0) {
                                            return 'red'
                                        } else if(params.data.site.alert - 0 > 0) {
                                            return 'orange'
                                        } else 
                                            return '#fff'
                                    },      
                                    shadowBlur: 10,
                                }
                            },
                        },
                        {
                            type: 'lines',    
                            zlevel: 2,                    // z-index
                            data: convertLineData(HZdata),    // 特效的起始、终点位置
                            effect: {
                                show: true,               // 动效是否显示
                                period: 4,                // 特效动画时间
                                trailLength: 0,         // 特效尾迹的长度
                                color: '#fff',            // 特效颜色
                                // symbol: 'arrow',       
                                symbolSize: 4             // 特效大小
                            },
                            lineStyle: {
                                normal: {                 // 正常情况下的线条样式
                                    color: '#fff',         //连线颜色
                                    width: 2,             
                                    curveness: -0.3       // 线条曲度
                                }
                            },
                            
                        }
                    ]
                }
                // 绘制图表
                myChart.setOption(option)
            },
            // 站点列表
            $_getSiteData: async function() {
                let params = {
                    zoom: 6
                }
                let data = await this.$api.bigScreenMap.getSiteData.call(this, params)
                if(data !== false) {
                    // console.log(data)
                    this.province = []
                    this.geoCoordMap = {}
                    this.site = []
                    for(let i of data) {
                        this.province.push({
                            name: i.name,
                            value: i.site_total - 0
                        })
                        this.geoCoordMap[i.name] = [
                            (i.longitude - 0).toFixed(2),
                            (i.latitude - 0).toFixed(2),
                        ]
                        this.site.push({
                            normal: i.site_total,
                            offline: i.site_offline_total,
                            alert: i.alert_untreated_total,
                        })
                    }
                }
            },
            // 合作伙伴配置
            $_getPartnerSetting:  async function() {
                let data = await this.$api.bigScreenMap.getPartnerSetting.call(this)
                if(data !== false) {
                    console.log(data)
                }
            },
            // 获取滚动告警列表
            $_getAlertContents: async function() {
                let data = await this.$api.bigScreenMap.getAlertContents.call(this)
                if(data !== false) {
                    let arr = []
                    for(let i of data) {
                        let str = `${i.occure_at} ${i.site_name} ${i.content} ${i.severity}`
                        arr.push(str)
                    }
                    this.alertContent = arr
                }
            },
            $_resize() {
                var myChart = echarts.init(document.getElementById('the-map'))
                window.onresize = function () {
                    myChart.resize({
                        width: document.body.width,
                        height: document.body.height
                    })
                }
            },
            $_closeMap() {
                this.$router.back()
                var myChart = echarts.init(document.getElementById('the-map'))
                myChart.dispose()
            },
            // 告警滚动 通过操作keyframe
            $_alertContentRolling: async function() {
                const getKeyframes = (name) => {
                    // 获取动画对象
                    var style = document.styleSheets
                    var index = 0
                    var arr = []
                    for (let i = 0; i < style.length; i++) {
                        var item = style[i].cssRules
                        for(let j = 0; j < item.length; j++) {
                            if(item[j].name === name) {
                                arr.push(j)
                                index = i
                            }
                        }
                    }
                    return { indexSheet: index, indexRule: arr }
                }
                // 不满一页时的处理
                while(this.alertContent.length < 9) {
                    this.alertContent = [...this.alertContent, ...this.alertContent]
                }

                // 滚动速度
                const speed = 24
                var contentLength = this.alertContent.length * 24
                var time = (contentLength * 100 / speed / 100).toFixed(2)

                var style = document.styleSheets
                var obj = await getKeyframes('mymove')
                for(let i = obj.indexRule.length -1; i >= 0; i--) {
                    style[obj.indexSheet].deleteRule(obj.indexRule[i])
                }
                const mymoveKeyframes = `
                    @keyframes mymove
                    {
                        from {transform: translateY(0);}
                        to {transform: translateY(-${contentLength}px);}
                    }`
                await style[obj.indexSheet].insertRule(mymoveKeyframes, obj.indexRule)
                this.alertContent = [...this.alertContent,...this.alertContent]
                var a = document.getElementById('li-container').style
                a.animation = `mymove ${time}s linear infinite`
            }
            
        },
        mounted: async function() {
            await this.$_getSiteData()
            await this.$_getPartnerSetting()
            await this.$_getAlertContents()
            await this.$_initMap()
            await this.$_resize()
            await this.$_alertContentRolling()
            this.loading = false
        }
    }
</script>

<style lang="less">
    @import url("../style/color.less");
    .big-screen-map {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
        z-index: 1100;
        background-image: url('../../public/img/map_background.jpg');
        #the-map {
            width: 100%;
            height: 100%;
            z-index: 1100;
            background-color: rgba(0, 0, 0 ,0.3);
            overflow: hidden;
            backface-visibility: hidden;
            padding: 15px;
        }
        .map-close {
            position: absolute;
            right: 20px;
            top: 20px;
            padding: 15px;
            border: none;
            border-radius: 50%;
            background-color: rgba(0, 0, 0, 0);
            z-index: 2101;
            &:hover {
                background-color: #484848;
            }
            i {
                font-size: 24px;
                color: #fff;
            }
        }
        .tooltip-item {
            text-align: left;
            margin-bottom: -40px;
            padding: 10px;
            &:last-child {
                margin-bottom: 0;
            }
        }

        .alert-contents {
            width: 25%;
            // height: 50%;
            height: ~ 'calc(30%)';
            padding: 0 15px;
            position: absolute;
            right: 20px;
            bottom: 20px;
            // background-color: rgba(31, 153, 183, .1);
            z-index: 1101;
            overflow: hidden;
            #li-container {
                li {
                    height: 24px;
                    line-height: 24px;
                    color: orange;
                    opacity: 0.5;
                    list-style-type: none;
                    text-align: left;
                    font-size: 10px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    cursor: default;
                }
                &:hover {
                    li {
                        opacity: 0.8;
                    }
                }
            }
        }

        .the-normal {
            color: white;
        }
        .the-offline {
            color: @Color-Error;
        }
        .the-alert {
            color: @Color-Warn;
        }


    }
    @keyframes mymove
    {
        from {transform: translateY(0);}
        to {transform: translateY(-100px);}
    }

</style>
